import React from 'react';

import {GraphWrapper} from './Graph';
import {type GraphRenderProps} from './graphRenderProps';
import {type RunsLinePlotPanelInnerProps} from './types';

/** Existing application inputs, owned by the compatibility boundary. */
export type GraphProps = RunsLinePlotPanelInnerProps & GraphRenderProps;

/** Selects consumed fields without deriving values or replacing references. */
export function GraphAdapter(props: GraphProps) {
  return (
    <GraphWrapper
      cappedPanel={props.cappedPanel}
      config={props.config}
      data={props.data}
      disableRunLinks={props.disableRunLinks}
      display={props.display}
      exportMode={props.exportMode}
      hasError={props.hasError}
      highlight={props.highlight}
      issueLines={props.issueLines}
      issueMarkers={props.issueMarkers}
      lines={props.lines}
      loading={props.loading}
      panelId={props.panelId}
      panelTitle={props.panelTitle}
      plotSettings={props.plotSettings}
      readOnly={props.readOnly}
      runNameTruncationType={props.runNameTruncationType}
      samplingWarning={props.samplingWarning}
      sizeRef={props.sizeRef}
      zoom={props.zoom}
      zoomUsage={props.zoomUsage}
    />
  );
}
